import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reset } from "redux-form";
import { withRouter } from "react-router-dom";
import api from "../api";
import Header from "../components/Header/Header";
import Login from "../components/Login";
import ForgotPassword from "../components/ForgotPassword";
import { loginAccount } from "../actions/login";
import { logoutAccount } from "../actions/logout";
import { forgotPassword } from "../actions/forgotPassword";
import {
  closeForgotPasswordModal,
  closeLoginModal,
  closeProfileEditorModal,
  closeProfileSelectorModal,
  closeRequestSentModal,
  closeSignUpModal,
  enterProfileManageMode,
  leaveProfileManageMode,
  openForgotPasswordModal,
  openLoginModal,
  openProfileEditorModal,
  openProfileSelectorModal,
  openRequestSentModal,
  openSignUpModal,
} from "../actions/auth";
import { setProfile } from "../actions/profile";
import { closeInviteModal, openInviteModal } from "../actions/invite";
import {
  closeBabyCreateModal,
  closeBabyEditorModal,
  menuClose,
  menuOpen,
} from "../actions/ui";
import { closeForgotPinModal } from "../actions/pin";
import {
  getAuthenticatedAccountId,
  getAuthenticatedIsAdmin,
  getAuthenticatedIsStaff,
} from "../selectors/auth";
import {
  getEditingProfile,
  getIsEditingCurrentProfile,
  getIsPrimaryProfile,
  getIsProfileEditorButtonDisabled,
  getProfileRoleOtherSelected,
  getSelectedProfile,
} from "../selectors/profiles";
import { getEditingBaby } from "../selectors/babies";
import { getRecentUnansweredQuestions } from "../selectors/questions";
import { getSignUp } from "../selectors/signUp";
import { getLogin } from "../selectors/login";
import { getForgotPassword } from "../selectors/forgotPassword";
import { getInvite } from "../selectors/invite";
/* import {
  getLearnModulesForCurrentLocale,
  getCurrentModule
} from '../selectors/modules'; */
import {
  getCurrentModuleWithLessonsAndProgress,
  getLessonProgressForCurrentProfile,
  getModuleProgressForCurrentProfile,
} from "../selectors/progress";
import { getLessons } from "../selectors/core";
import { getMenus } from "../selectors/menus";

class HeaderContainer extends Component {
  constructor(props) {
    super(props);

    this.fetchMenuItems = this.fetchMenuItems.bind(this);
    this.fetchAskList = this.fetchAskList.bind(this);
    this.fetchProfiles = this.fetchProfiles.bind(this);
    this.fetchRoles = this.fetchRoles.bind(this);

    this.handleOpenSignUpModal = this.handleOpenSignUpModal.bind(this);
    this.handleCloseSignUpModal = this.handleCloseSignUpModal.bind(this);
    this.handleOpenRequestSentModal = this.handleOpenRequestSentModal.bind(
      this
    );
    this.handleCloseRequestSentModal = this.handleCloseRequestSentModal.bind(
      this
    );
    this.handleOpenLoginModal = this.handleOpenLoginModal.bind(this);
    this.handleCloseLoginModal = this.handleCloseLoginModal.bind(this);
    // this.handleSignUp = this.handleSignUp.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleOpenForgotPasswordModal = this.handleOpenForgotPasswordModal.bind(
      this
    );
    this.handleCloseForgotPasswordModal = this.handleCloseForgotPasswordModal.bind(
      this
    );
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleSelectProfile = this.handleSelectProfile.bind(this);
    this.handleEnterProfileManageMode = this.handleEnterProfileManageMode.bind(
      this
    );
    this.handleLeaveProfileManageMode = this.handleLeaveProfileManageMode.bind(
      this
    );
    this.handleOpenProfileEditorModal = this.handleOpenProfileEditorModal.bind(
      this
    );
    this.handleCloseProfileEditorModal = this.handleCloseProfileEditorModal.bind(
      this
    );
    this.handleCloseProfileSelectorModal = this.handleCloseProfileSelectorModal.bind(
      this
    );
    this.handleCloseInviteModal = this.handleCloseInviteModal.bind(this);
    this.handleDeleteProfile = this.handleDeleteProfile.bind(this);
    this.handleInvite = this.handleInvite.bind(this);
    this.handleCloseBabyEditorModal = this.handleCloseBabyEditorModal.bind(
      this
    );
    this.handleCloseBabyCreateModal = this.handleCloseBabyCreateModal.bind(
      this
    );
    this.handleCloseForgotPinModal = this.handleCloseForgotPinModal.bind(this);
    this.handleForgotPin = this.handleForgotPin.bind(this);

    this.state = {
      duplicatedEmailError: false,
    };
  }

  componentDidMount() {
    this.fetchMenuItems();
    this.fetchProfiles();
    this.fetchRoles();
    this.fetchAskList();
    if (this.props.isAuthenticated) {
      this.props.dischargeStepsList({});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.accountId !== prevProps.accountId) {
      this.fetchProfiles();

      if (prevProps.accountId === null) {
        this.fetchRoles();
      }
    }

    if (
      this.props.profile !== null &&
      (prevProps.profile === null ||
        this.props.profile.id !== prevProps.profile.id)
    ) {
      this.fetchAskList();
    }
  }

  handleOpenSignUpModal() {
    this.props.openSignUpModal();
  }

  handleCloseSignUpModal() {
    this.props.closeSignUpModal();
  }

  // handleSignUp(values) {
  //   return this.props.createRequest(
  //     {},
  //     {
  //       body: JSON.stringify({
  //         ...values
  //       })
  //     }
  //   ).then(data => {
  //     if (data.status === 409) {
  //       throw new Error('An account already exists for that email.');
  //     } else {
  //       this.props.closeSignUpModal();
  //       this.props.openRequestSentModal();
  //     }
  //   }).catch(error => {
  //     this.setState({
  //       duplicatedEmailError: true
  //     });
  //   })
  // }

  handleOpenRequestSentModal() {
    this.props.openRequestSentModal();
  }

  handleCloseRequestSentModal() {
    this.props.closeRequestSentModal();
  }

  handleOpenLoginModal() {
    this.props.openLoginModal();
  }

  handleCloseLoginModal() {
    this.props.closeLoginModal();
  }

  handleLogin(values) {
    this.props.loginAccount(
      {
        email: values.email.trim(),
        password: values.password.trim(),
      },
      this.props.history
    );
  }

  handleLogout() {
    this.props.logoutAccount(this.props.token);
  }

  handleOpenForgotPasswordModal() {
    this.props.openForgotPasswordModal();
  }

  handleCloseForgotPasswordModal() {
    this.props.closeForgotPasswordModal();
  }

  handleForgotPassword(values) {
    this.props.forgotPassword(values.email.trim());
  }

  handleSelectProfile(profileId) {
    this.props.setProfile(profileId);
  }

  handleEnterProfileManageMode() {
    this.props.enterProfileManageMode();
  }

  handleLeaveProfileManageMode() {
    this.props.leaveProfileManageMode();
  }

  handleOpenProfileEditorModal(profileId) {
    this.props.openProfileEditorModal(profileId);
  }

  handleCloseProfileEditorModal() {
    this.props.resetForm("profileEditor");
    this.props.closeProfileEditorModal();
  }

  handleCloseProfileSelectorModal() {
    this.props.closeProfileSelectorModal();
  }

  handleCloseInviteModal() {
    this.props.closeInviteModal();
  }

  handleCloseBabyEditorModal() {
    this.props.closeBabyEditorModal();
  }

  handleCloseBabyCreateModal() {
    this.props.closeBabyCreateModal();
  }

  handleDeleteProfile(profileId) {
    this.props
      .deleteProfile({ accountId: this.props.accountId, profileId })
      .then(() => {
        this.fetchProfiles();
        this.props.closeProfileEditorModal();
      });
  }

  handleInvite(values) {
    this.props.invitesCreate({}, { body: JSON.stringify(values) });
  }

  handleCloseForgotPinModal() {
    this.props.closeForgotPinModal();
  }

  handleForgotPin() {
    if (this.props.accountId && this.props.profile && this.props.profile.id) {
      this.props.pinForgot(
        {},
        {
          body: JSON.stringify({
            accountId: this.props.accountId,
            profileId: this.props.profile.id,
          }),
        }
      );
    }
  }

  fetchMenuItems() {
    this.props.menuList();
  }

  fetchAskList() {
    if (this.props.accountId && this.props.profile && this.props.profile.id) {
      this.props.questionsList({
        accountId: this.props.accountId,
        profileId: this.props.profile.id,
      });
    }
  }

  fetchProfiles() {
    if (this.props.accountId) {
      this.props.profilesList({
        accountId: this.props.accountId,
      });
    }
  }

  fetchRoles() {
    if (this.props.accountId) {
      this.props.rolesList();
    }
  }

  render() {
    return (
      <Header
        {...this.props}
        fetchAskList={this.fetchAskList}
        handleOpenSignUpModal={this.handleOpenSignUpModal}
        handleCloseSignUpModal={this.handleCloseSignUpModal}
        handleSignUp={this.handleSignUp}
        handleOpenRequestSentModal={this.handleOpenRequestSentModal}
        handleCloseRequestSentModal={this.handleCloseRequestSentModal}
        handleOpenLoginModal={this.handleOpenLoginModal}
        handleCloseLoginModal={this.handleCloseLoginModal}
        handleLogin={this.handleLogin}
        handleLogout={this.handleLogout}
        handleSelectProfile={this.handleSelectProfile}
        handleForgotPassword={this.handleForgotPassword}
        handleOpenForgotPasswordModal={this.handleOpenForgotPasswordModal}
        handleCloseForgotPasswordModal={this.handleCloseForgotPasswordModal}
        handleOpenProfileEditorModal={this.handleOpenProfileEditorModal}
        handleCloseProfileEditorModal={this.handleCloseProfileEditorModal}
        handleCloseProfileSelectorModal={this.handleCloseProfileSelectorModal}
        handleCloseInviteModal={this.handleCloseInviteModal}
        handleEnterProfileManageMode={this.handleEnterProfileManageMode}
        handleLeaveProfileManageMode={this.handleLeaveProfileManageMode}
        handleDeleteProfile={this.handleDeleteProfile}
        handleInvite={this.handleInvite}
        handleCloseBabyEditorModal={this.handleCloseBabyEditorModal}
        handleCloseBabyCreateModal={this.handleCloseBabyCreateModal}
        handleCloseForgotPinModal={this.handleCloseForgotPinModal}
        handleForgotPin={this.handleForgotPin}
        duplicatedEmailError={this.state.duplicatedEmailError}
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const accountId = state.auth.hasToken
    ? getAuthenticatedAccountId(state)
    : null;
  const isAdmin = state.auth.hasToken ? getAuthenticatedIsAdmin(state) : false;
  const isStaff = state.auth.hasToken ? getAuthenticatedIsStaff(state) : false;
  const module = getCurrentModuleWithLessonsAndProgress(state, ownProps);
  const moduleProgress = getModuleProgressForCurrentProfile(state);
  const lessons = getLessons(state, ownProps);
  const lessonProgress = getLessonProgressForCurrentProfile(state);

  return {
    menuShow: state.ui.menuShow,
    isAuthenticated: state.auth.hasToken && state.auth.hasProfile,
    location: state.router.location,
    accountId,
    isAdmin,
    isStaff,
    token: state.auth.token,
    profile: getSelectedProfile(state),
    editingProfile: getEditingProfile(state),
    editingBaby: getEditingBaby(state),
    questions: getRecentUnansweredQuestions(state),
    signUpProps: getSignUp(state),
    loginProps: getLogin(state),
    forgotPasswordProps: getForgotPassword(state),
    inviteProps: getInvite(state),
    isEditingCurrentProfile: getIsEditingCurrentProfile(state),
    isForgotPasswordModalOpen: state.auth.isForgotPasswordModalOpen,
    isRequestSentModalOpen: state.auth.isRequestSentModalOpen,
    isSignUpModalOpen: state.auth.isSignUpModalOpen,
    isLoginModalOpen: state.auth.isLoginModalOpen,
    isLoadingProfiles:
      !state.profilesList.sync ||
      state.profilesList.loading ||
      !state.rolesList.sync ||
      state.rolesList.loading,
    isLoadingProfile:
      state.profilesPost.loading ||
      state.profilesPatch.loading ||
      state.profilesDelete.loading,
    isManagingProfiles: state.auth.isManagingProfiles,
    isPrimaryProfile: getIsPrimaryProfile(state),
    isProfileEditorModalOpen: state.auth.isProfileEditorModalOpen,
    isProfileEditorButtonDisabled: getIsProfileEditorButtonDisabled(state),
    isProfileEditorErrorMessageVisible:
      state.auth.isProfileEditorErrorMessageVisible,
    isProfileSelectorModalOpen: state.auth.isProfileSelectorModalOpen,
    editBabyId: state.ui.editBabyId,
    isRoleOtherSelected: getProfileRoleOtherSelected(state),
    isInviteModalOpen: state.invites.isInviteModalOpen,
    isBabyCreateModalOpen: state.ui.babyCreateModalShown,
    isForgotPinModalOpen: state.pin.isForgotPinModalOpen,
    isForgotPinModalLoading: state.pinForgot.loading,
    isForgotPinSuccessMessageVisible:
      state.pin.isForgotPinSuccessMessageVisible,
    isForgotPinFailureMessageVisible:
      state.pin.isForgotPinFailureMessageVisible,
    roles: state.role.all,
    module,
    moduleProgress,
    lessons,
    lessonProgress,
    menuItems: state.menuList.loading ? null : getMenus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      menuOpen,
      menuClose,
      openSignUpModal,
      closeSignUpModal,
      openRequestSentModal,
      closeRequestSentModal,
      openLoginModal,
      closeLoginModal,
      loginAccount,
      logoutAccount,
      forgotPassword,
      openForgotPasswordModal,
      closeForgotPasswordModal,
      onChangeProfileClick: openProfileSelectorModal,
      onInviteClick: openInviteModal,
      questionsList: api.actions.questionsList.force,
      menuList: api.actions.menuList,
      profilesList: api.actions.profilesList,
      rolesList: api.actions.rolesList,
      invitesCreate: api.actions.invitesCreate,
      setProfile,
      openProfileEditorModal,
      closeProfileEditorModal,
      closeProfileSelectorModal,
      enterProfileManageMode,
      leaveProfileManageMode,
      closeInviteModal,
      createProfile: api.actions.profilesPost,
      deleteProfile: api.actions.profilesDelete,
      updateProfile: api.actions.profilesPatch,
      babiesPatch: api.actions.babiesPatch,
      babiesPatchReset: api.actions.babiesPatch.reset,
      resetForm: reset,
      closeBabyEditorModal,
      closeBabyCreateModal,
      pinForgot: api.actions.pinForgot,
      closeForgotPinModal,
      dischargeStepsList: api.actions.dischargeSteps,
      createRequest: api.actions.requestsCreate,
    },
    dispatch
  );
}

HeaderContainer.defaultProps = {
  questions: [],
  accountId: null,
  profile: null,
  token: null,
};

HeaderContainer.propTypes = {
  accountId: PropTypes.string,
  token: PropTypes.string,
  profile: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      question: PropTypes.string,
      details: PropTypes.string,
      date: PropTypes.date,
      pathname: PropTypes.string,
      answered: PropTypes.bool,
    })
  ),
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      other: PropTypes.bool,
    })
  ).isRequired,
  loginProps: PropTypes.shape(Login.propTypes).isRequired,
  forgotPasswordProps: PropTypes.shape(ForgotPassword.propTypes),
  inviteProps: PropTypes.shape(ForgotPassword.propTypes),
  openSignUpModal: PropTypes.func.isRequired,
  closeSignUpModal: PropTypes.func.isRequired,
  openLoginModal: PropTypes.func.isRequired,
  closeLoginModal: PropTypes.func.isRequired,
  loginAccount: PropTypes.func.isRequired,
  logoutAccount: PropTypes.func.isRequired,
  openForgotPasswordModal: PropTypes.func.isRequired,
  closeForgotPasswordModal: PropTypes.func.isRequired,
  forgotPassword: PropTypes.func.isRequired,
  invitesCreate: PropTypes.func.isRequired,
  questionsList: PropTypes.func.isRequired,
  menuList: PropTypes.func.isRequired,
  profilesList: PropTypes.func.isRequired,
  rolesList: PropTypes.func.isRequired,
  onChangeProfileClick: PropTypes.func.isRequired,
  onInviteClick: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired, // eslint-disable-line
  isAuthenticated: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  setProfile: PropTypes.func.isRequired,
  openProfileEditorModal: PropTypes.func.isRequired,
  closeProfileEditorModal: PropTypes.func.isRequired,
  closeProfileSelectorModal: PropTypes.func.isRequired,
  closeBabyEditorModal: PropTypes.func.isRequired,
  closeBabyCreateModal: PropTypes.func.isRequired,
  closeInviteModal: PropTypes.func.isRequired,
  enterProfileManageMode: PropTypes.func.isRequired,
  leaveProfileManageMode: PropTypes.func.isRequired,
  createProfile: PropTypes.func.isRequired,
  deleteProfile: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
  babiesPatch: PropTypes.func.isRequired,
  babiesPatchReset: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  closeForgotPinModal: PropTypes.func.isRequired,
  pinForgot: PropTypes.func.isRequired,
  menuShow: PropTypes.bool.isRequired,
  menuOpen: PropTypes.func.isRequired,
  menuClose: PropTypes.func.isRequired,
  dischargeStepsList: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderContainer)
);



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js